import swal from 'vue-swal'
import Vue from 'vue'

Vue.use(swal)
